/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { FileTypePdfIcon16Light } from './FileTypePdfIcon16Light';
import { FileTypePdfIcon16Regular } from './FileTypePdfIcon16Regular';
import { FileTypePdfIcon16Solid } from './FileTypePdfIcon16Solid';
import { FileTypePdfIcon20Light } from './FileTypePdfIcon20Light';
import { FileTypePdfIcon20Regular } from './FileTypePdfIcon20Regular';
import { FileTypePdfIcon20Solid } from './FileTypePdfIcon20Solid';
import { FileTypePdfIcon24Regular } from './FileTypePdfIcon24Regular';
import { FileTypePdfIcon24Solid } from './FileTypePdfIcon24Solid';
import { FileTypePdfIcon32Regular } from './FileTypePdfIcon32Regular';
import { FileTypePdfIcon64Regular } from './FileTypePdfIcon64Regular';
var sizes = {
    16: {
        light: FileTypePdfIcon16Light,
        regular: FileTypePdfIcon16Regular,
        solid: FileTypePdfIcon16Solid,
    },
    20: {
        light: FileTypePdfIcon20Light,
        regular: FileTypePdfIcon20Regular,
        solid: FileTypePdfIcon20Solid,
    },
    24: {
        regular: FileTypePdfIcon24Regular,
        solid: FileTypePdfIcon24Solid,
    },
    32: {
        regular: FileTypePdfIcon32Regular,
    },
    64: {
        regular: FileTypePdfIcon64Regular,
    },
};
export var FileTypePdfIcon = forwardRef('FileTypePdfIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
